import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';

import css from './order-details-board.less';

class OrderDetailsBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      pickUpLocationKeyword,
      dropOffLocationKeyword,
      senderName,
      receiverName,
      senderPhone,
      receiverPhone,
      serviceType,
      paymentMethod,
      vehicleType,
      referenceCode,
      itemWeight,
    } = this.props;

    return (
      <div className={css.orderDetailsBoard}>
        <div className={css.locationDetails}>
          <div className={css.locationContainer}>
            <div className={css.icon}>
              <img src={require('public/images/pick-up.svg')} alt="" />
            </div>
            <div className={css.text}>
              <h5>{pickUpLocationKeyword}</h5>
              <h6>{`${senderName}  |  ${senderPhone}`}</h6>
            </div>
          </div>
          <div className={css.locationContainer}>
            <div className={css.icon}>
              <img src={require('public/images/drop-off.svg')} alt="" />
            </div>
            <div className={css.text}>
              <h5>{dropOffLocationKeyword}</h5>
              <h6>{`${receiverName}  |  ${receiverPhone}`}</h6>
            </div>
          </div>
        </div>
        <div className={css.deliveryDetails}>
          <div className={css.deliveryInfoContainer}>
            <h6>{I18n.t('v2.orderTable.column.deliveryType')}</h6>
            <h5>{serviceType}</h5>
          </div>
          <div className={css.deliveryInfoContainer}>
            <h6>{I18n.t('booking.fieldLabel.vehicleType')}</h6>
            <h5>{vehicleType}</h5>
          </div>
          <div className={css.deliveryInfoContainer}>
            <h6>{I18n.t('booking.fieldLabel.weight')}</h6>
            <h5>{`${itemWeight} kg`}</h5>
          </div>
          <div className={css.deliveryInfoContainer}>
            <h6>{I18n.t('booking.fieldLabel.paymentMethod')}</h6>
            <h5>{paymentMethod}</h5>
          </div>
          <div className={css.deliveryInfoContainer}>
            <h6>{I18n.t('v2.orderTable.column.referenceCode')}</h6>
            <h5>{referenceCode}</h5>
          </div>
          <div className={css.deliveryInfoContainer} />
        </div>
      </div>
    );
  }
}

OrderDetailsBoard.propTypes = {
  pickUpLocationKeyword: PropTypes.string,
  dropOffLocationKeyword: PropTypes.string,
  senderName: PropTypes.string,
  receiverName: PropTypes.string,
  senderPhone: PropTypes.string,
  receiverPhone: PropTypes.string,
  serviceType: PropTypes.string,
  paymentMethod: PropTypes.string,
  vehicleType: PropTypes.string,
  referenceCode: PropTypes.string,
  itemWeight: PropTypes.number,
};

OrderDetailsBoard.defaultProps = {
  pickUpLocationKeyword: '-',
  dropOffLocationKeyword: '-',
  senderName: '-',
  receiverName: '-',
  senderPhone: '-',
  receiverPhone: '-',
  serviceType: '-',
  paymentMethod: '-',
  vehicleType: '-',
  referenceCode: '-',
  itemWeight: 0,
};

export default OrderDetailsBoard;
